import React from "react";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaPaginatedDropdown,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../components";
import { Formik } from "formik";

const CreateInflowModal = ({
  closeModal,
  onSubmit,
  loading,
  validationSchema,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <>
        <MimaText variant="subtitleBold" mb={4}>
          Create Wallet Inflow
        </MimaText>

        <Formik
          initialValues={{
            amountPaid: 0,
            currencyCode: "",
            business: "",
            businessName: "",
            invoiceNumber: "",
            transactionReference: "",
            narration: "",
          }}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({
            handleBlur,
            handleChange,
            setFieldValue,
            values,
            errors,
            touched,
            handleSubmit,
          }) => (
            <>
              <div className="modal__beside">
                <MimaDropdown
                  labelTitle="Select Currency"
                  placeholder="Select"
                  name="currencyCode"
                  value={values.currencyCode}
                  id="currencyCode"
                  data={[
                    { value: "USD", key: "USD" },
                    { value: "GBP", key: "GBP" },
                    { value: "EUR", key: "EUR" },
                    { value: "NGN", key: "NGN" },
                  ]}
                  onChange={(data) => {
                    setFieldValue("currencyCode", data.key);
                  }}
                  width={18}
                  error={errors.currencyCode}
                  touched={touched.currencyCode}
                />
                <MimaInput
                  labelTitle="Amount"
                  type="number"
                  placeholder="Enter Amount"
                  id="amountPaid"
                  name="amountPaid"
                  value={values.amountPaid}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.amountPaid}
                  touched={touched.amountPaid}
                  width={18}
                />
              </div>

              <MimaPaginatedDropdown
                type="text"
                name="businessName"
                id="businessName"
                value={values.businessName}
                queryKey={["getAllSignedBusinesses"]}
                optionLabel="tradingName"
                labelTitle="Select business"
                placeholder="Select business"
                touched={touched?.businessName}
                error={errors?.businessName}
                url="/businesses"
                getPageValue={(page) => page?.data?.businesses || []}
                getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
                onChange={(data) => {
                  setFieldValue("business", data._id);
                  setFieldValue("businessName", data.tradingName);
                }}
                width={38}
                mt={2}
              />

              <MimaInput
                labelTitle="Invoice number (optional)"
                placeholder="Enter invoice number"
                id="invoiceNumber"
                name="invoiceNumber"
                value={values.invoiceNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.invoiceNumber}
                touched={touched.invoiceNumber}
              />
              <MimaInput
                labelTitle="Transaction Reference"
                placeholder="Enter Transaction Reference"
                id="transactionReference"
                name="transactionReference"
                value={values.transactionReference}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.transactionReference}
                touched={touched.transactionReference}
              />
              <MimaTextArea
                labelTitle="Narration"
                placeholder="Enter narration"
                id="narration"
                name="narration"
                value={values.narration}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.narration}
                touched={touched.narration}
              />
              <MimaButton
                title="Confirm Action"
                type="submit"
                onClick={handleSubmit}
                width={38}
                buttonColor="var(--color-admin)"
                loading={loading}
              />
            </>
          )}
        </Formik>
      </>
    </Modal>
  );
};
export default CreateInflowModal;
